import { DocumentType, ResourceType } from '../core/types';

export const resourceTypeToLegacy = (
	type: ResourceType | DocumentType
): Exclude<DocumentType, 'checkouts'> | 'orders' | 'integrations' | 'groups' | 'documents' | 'attachments' => {
	// @ts-expect-error - this handles variations of checkout type
	if (type === ResourceType.CHECKOUTS || type === 'check-outs' || type === 'check-out') {
		return 'orders';
	}
	return type;
};
